import alt from 'framework/alt';
import ProfileImageActions from 'actions/media/ProfileImageActions';
import ProfileImageResponseParser from 'stores/profileImage/ProfileImageResponseParser';

class ProfileImageStore {
  constructor() {
    this.state = {
      profileImages: {},
    };

    this.bindListeners({
      delete: ProfileImageActions.deleteSucceeded,
      failed: [
        ProfileImageActions.createFailed,
        ProfileImageActions.deleteFailed,
        ProfileImageActions.fetchFailed,
      ],
      put: [ProfileImageActions.createSucceeded, ProfileImageActions.fetchSucceeded],
    });
  }

  delete(amazonAuthorId) {
    const { profileImages } = this.state;

    delete profileImages[amazonAuthorId];

    this.setState({
      profileImages,
      error: null,
    });
  }

  failed(err) {
    this.setState({
      error: err,
    });
  }

  put(params) {
    const { profileImages } = this.state;
    const profileImage = ProfileImageResponseParser.parse(params.response);
    profileImages[params.amazonAuthorId] = profileImage || {};

    this.setState({
      error: null,
      profileImages,
    });
  }
}

export default alt.createStore(ProfileImageStore, 'ProfileImageStore');
